<template>
    <div>
        <div class="w-full flex justify-center -mb-8">
            <vs-upload
                    action="#"
                    :limit="1"
                    ref="uploader"
                    :show-upload-button="false"
                    text="Добавить файл"
                    @change="changeFile"
                    @on-delete="deleteFile"
                    class="w-auto mx-auto"
                    accept="text/plain"
            />
        </div>
        <div class="w-full text-center mt-4">
            <vs-button type="border" color="success" @click="upload">Загрузить</vs-button>
        </div>
        <div class="w-full text-center mt-4">
            <p>Формат файла - txt.</p>
            <p>Скачать пример можно <a href="#">здесь</a></p>
            <p><a href="#" @click.prevent="checkMail">Проверить почту</a></p>
        </div>



        <vs-popup :active.sync="isIdenticPaymentsOpen" title="Найденные платежи" class="identicPaymentsPopup">
            <div class="vx-row flex-wrap">
               <div class="vx-col w-full flex flex-wrap justify-center align-center">
                   <p class="mb-base mr-4"><span class="font-medium">Всего платежей:</span> {{Number(identicPayments.unique_qty) + Number(identicPayments.identic_qty)}}</p>
                   <p class="mb-base mr-4"><span class="font-medium">Новых платежей:</span> {{identicPayments.unique_qty}}</p>
                   <p class="mb-base mr-4"><span class="font-medium">Платежи похожие на уже существующие:</span> {{identicPayments.identic_qty}}</p>
               </div>
            </div>

            <div class="vx-row mb-3">
                <div class="vx-col w-full">
                    <vs-table multiple v-model="selectedIdenticPayments"  max-items="20" pagination :data="identicPayments.identic_invoices">
                        <template slot="thead">
                            <vs-th>Л/с</vs-th>
                            <vs-th>Сумма</vs-th>
                            <vs-th><div class="w-full text-center">Платежи похожие на уже существующие</div></vs-th>
                            </template>

                        <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                    <vs-td>
                                        {{tr.new.account_number}}
                                    </vs-td>
                                    <vs-td>
                                        {{tr.new.amount}}
                                    </vs-td>
                                    <vs-td>
                                        <vs-table :data="tr.old">
                                            <template slot="thead">
                                                <vs-th style="width: 120px">Дата создания</vs-th>
                                                <vs-th style="width: 140px">Дата проведения</vs-th>
                                                <vs-th style="width: 180px">Обновление в системе</vs-th>
                                                <vs-th>Источник</vs-th>
                                            </template>
                                            <template slot-scope="{data}">
                                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                                                    <vs-td>
                                                        {{$options.filters.moment($parseDateFromString(tr.payment_create_date))}}
                                                    </vs-td>
                                                    <vs-td>
                                                        {{$options.filters.moment($parseDateFromString(tr.payment_passage_date))}}
                                                    </vs-td>
                                                    <vs-td>
                                                        {{$options.filters.moment(tr.updated_at)}}
                                                    </vs-td>
                                                    <vs-td>
                                                        {{tr.author ? tr.author.name : tr.resolved_by}}
                                                    </vs-td>
                                                </vs-tr>
                                            </template>
                                        </vs-table>
                                    </vs-td>
                                </vs-tr>
                        </template>


                    </vs-table>
                </div>
            </div>

            <div class="vx-row mb-3">
                <div class="vx-col w-full flex items-center justify-center">
                    <vs-button class="mr-4" @click="addIdenticPayments(true)">Добавить ({{Number(identicPayments.unique_qty + selectedIdenticPaymentsIndexs.length)}})</vs-button>
                    <vs-button class="mr-4" @click="addIdenticPayments(false)">Добавить только новые ({{identicPayments.unique_qty}})</vs-button>
                    <vs-button class="mr-4" type="border" @click="isIdenticPaymentsOpen = false">Отменить</vs-button>
                </div>
            </div>


        </vs-popup>

    </div>
</template>

<script>
    export default {
        name: "UploadSberbankTxt",
        data(){
            return {
                file: null,
                isIdenticPaymentsOpen: false,
                selectedIdenticPayments: [],
                selectedIdenticPaymentsIndexs: [],
                identicPayments: {
                    identic_invoices: []
                }
            }
        },
        methods: {
            changeFile(event, file){
                this.file = file[file.length-1];
            },
            deleteFile(){
                this.file = null;
            },
            async addIdenticPayments(force){
                if(!this.file) return;
                let body = new FormData();
                body.append('reestr', this.file);
                body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
                body.append('users_id', this.$store.getters['appUser/id']);
                body.append('force', force);

                this.$vs.loading({type:'default'});
                if(force === true){
                    body.append('list', JSON.stringify(this.selectedIdenticPaymentsIndexs));
                }

                try{
                    let {data} = await this.$http.post('import/sberbank', body);
                    if (data === 'error') {
                        this.$vs.notify({color: 'danger', title: 'Ошибка загрузки', text: 'Файл не загружен'});
                    }else{
                        this.isIdenticPaymentsOpen = false;
                        this.$emit('uploaded', {info: data.log});
                        this.$vs.notify({color: 'success', title: 'Импорт завершен', text: 'Файл импортирован'});
                        this.resetFile();
                    }
                }
                catch(e){
                    this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Не удалось добавить платежи'});
                }
                finally {
                    this.$nextTick(() => {
                        this.$vs.loading.close();
                    });
                }


            },
            async upload(){
                if(!this.file) return;
                let body = new FormData();
                body.append('reestr', this.file);
                body.append('buildings_id', this.$store.getters['appUser/selectedHouse'].id);
                body.append('users_id', this.$store.getters['appUser/id']);
                this.$vs.loading({type:'default'});
                try {
                    let {data} = await this.$http.post('import/sberbank', body);
                    if (data === 'error') {
                        this.$vs.notify({color: 'danger', title: 'Ошибка загрузки', text: 'Файл не загружен'});
                    }else if(data === 'file already uploaded'){
                        this.$vs.notify({color: 'danger', title: 'Ошибка загрузки', text: 'Данный файл уже импортирован'});
                    } else {
                        if(data.identic_qty > 0){
                            this.identicPayments =  data;
                            this.isIdenticPaymentsOpen = true;
                        }else{
                            this.isIdenticPaymentsOpen = false;
                            this.$emit('uploaded', {info: data.log});
                            this.$vs.notify({color: 'success', title: 'Импорт завершен', text: 'Файл импортирован'});
                            this.resetFile();
                        }
                    }
                }
                catch(error){
                    if (e.response) {
                        if(e.response.status === 403){
                            this.$vs.notify({color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав'});
                        }
                        else{
                            this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже'});
                        }
                    }
                    else{
                        this.$vs.notify({color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка'});
                    }
                }
                finally {
                    this.$nextTick(() => {
                        this.$vs.loading.close();
                    });
                }
            },
            async checkMail(){
                try {
                    let {data} = await this.$http.get('import/sberbank_mail', {
                        params: {
                            buildings_id: this.$store.getters['appUser/selectedHouse'].id
                        }
                    });

                    if(data === 'no config found'){
                        this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Файл конфигурации не найден'})
                    }
                    else{
                        this.$vs.notify({color: 'success', title: 'Почта проверена', text: `Импортировано ${data.files_saved} файлов`})
                    }



                }
                catch(error){
                    this.$vs.notify({color: 'danger', title: 'Ошибка сервера', text: 'Не удалось проверить почту'})
                }


            },
            resetFile(){
                this.file = null;
                this.$refs.uploader.srcs = [];
                this.$refs.uploader.itemRemove = [];
                this.$refs.uploader.filesx = [];
            }
        },
        watch: {
            selectedIdenticPayments(){
                this.selectedIdenticPaymentsIndexs = [];

                this.selectedIdenticPayments.forEach(payment => {
                    let index = this.identicPayments.identic_invoices.findIndex(identicPayment => identicPayment === payment);
                    if(index !== -1){
                        this.selectedIdenticPaymentsIndexs.push(index);
                    }
                })

            }
        }
    }
</script>

<style lang="scss">
    .identicPaymentsPopup{
        .vs-popup{
            width: 1000px;
        }
    }
</style>